import request from '@/utils/request'

// 登录
export function login (params) {
  return request.post('/admin/login', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}

// 退出登录
export function logout () {
  return request.post('/admin/logout', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}

// 修改密码
export function modifyPassword (params) {
  return request.post('/user/updatePass', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}

// 发送验证码
export function sendSms (params) {
  return request.post('https://service.yishifuwu.cn/api/b/sms/sendSms', params)
}

// 校验验证码
export function checkCode (params) {
  return request.post('https://service.yishifuwu.cn/api/b/user/checkCode', params)
}

// 修改手机号
export function saveUser (params) {
  return request.post('/user/updatePhone', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}

// 获取谷歌令牌
export function getQrCode (params) {
  return request.get(`/admin/getQrCode?userId=${params.userId}`)
}

// 重置谷歌令牌
export function resetQrCode (params) {
  return request.get(`/admin/resetQrCode?userId=${params.userId}`)
}

// 校验谷歌令牌
export function checkQrCode (params) {
  return request.post('/admin/checkQrCode', params)
}

// 添加私有ip
export function addPrivate () {
  return request.get('/ipList/addPrivateIp')
}

// 添加私有ip
export function trustBrowser (params) {
  return request.get(`/ipList/trustBrowser?browser=${params.browser}`)
}
